import React from "react";
import { Instagram, Music2, Youtube, Twitch, ArrowUpRight } from "lucide-react";
import { creators } from "../mock";

const ICONS = { instagram: Instagram, tiktok: Music2, youtube: Youtube, twitch: Twitch };

export default function Creators() {
  return (
    <section id="creators" className="glow-teal relative overflow-hidden bg-transparent py-24 md:py-32">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <div className="reveal mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <span className="mono-label text-xs text-[var(--crtr-yellow)]">{creators.kicker}</span>
            <h2 className="font-display mt-4 text-6xl text-white sm:text-7xl md:text-8xl">
              {creators.title[0]}<br />
              <span className="text-[var(--crtr-yellow)]">{creators.title[1]}))</span>
            </h2>
          </div>
          <p className="max-w-sm text-base leading-relaxed text-white/65">{creators.body}</p>
        </div>

        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
          {creators.list.map((c) => (
            <div
              key={c.name}
              className="group relative aspect-[3/4] overflow-hidden rounded-2xl bg-neutral-800"
            >
              <img
                src={c.image}
                alt={c.name}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
              {c.ai && <span className="ai-badge" style={{ bottom: "auto", top: "0.75rem", left: "0.75rem", right: "auto" }}>KI-generiert</span>}

              <a
                href={c.href}
                target="_blank"
                rel="noreferrer"
                aria-label={`${c.name} auf Instagram`}
                className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-black/40 text-white opacity-0 backdrop-blur-sm transition-opacity hover:bg-[var(--crtr-yellow)] hover:text-black group-hover:opacity-100"
              >
                <ArrowUpRight className="h-4 w-4" />
              </a>

              <div className="absolute inset-x-0 bottom-0 p-4">
                <h3 className="font-heavy text-xl uppercase leading-none text-white sm:text-2xl">{c.name}</h3>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {c.stats.map((s, i) => {
                    const Icon = ICONS[s.p];
                    return (
                      <a
                        key={i}
                        href={s.url}
                        target="_blank"
                        rel="noreferrer"
                        aria-label={`${c.name} ${s.p}`}
                        className="inline-flex items-center gap-1 rounded-full bg-[var(--crtr-yellow)] px-2 py-1 text-[11px] font-bold text-black transition-transform hover:scale-105"
                      >
                        {Icon && <Icon className="h-3.5 w-3.5" strokeWidth={2.2} />}
                        {s.v}
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
